var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('br'),_c('br'),_c('br'),_c('br'),_c('my-project'),_c('a',{attrs:{"id":"beian","href":"https://beian.miit.gov.cn/"}},[_vm._v("京ICP备2021029079号-1")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }